<template>
  <div class="register_page">
    <div class="content_box">
      <div class="register_form">
        <div class="title">重置密码</div>
        <div class="form_box">
          <el-form ref="form" :model="registerForm" label-width="100px">
            <el-form-item label="账号" v-if="!$route.query.phoneOrEmail">
              <el-input
                v-model="registerForm.phoneOrEmail"
                placeholder="手机号/邮箱地址"
                class="input_box"
              ></el-input>
            </el-form-item>
            <el-form-item label="登录密码" v-if="$route.query.phoneOrEmail">
              <el-input
                v-model="registerForm.password"
                placeholder="输入登录密码"
                type="password"
                class="input_box"
              ></el-input>
            </el-form-item>
            <el-form-item label="确认密码" v-if="$route.query.phoneOrEmail">
              <el-input
                v-model="registerForm.passwordAgain"
                placeholder="确保密码输入正确"
                type="password"
                class="input_box"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <div class="action_box">
                <el-button type="info" @click="toCancel">取消</el-button>
                <el-button type="primary" @click="toSubmit" v-if="$route.query.phoneOrEmail">提交</el-button>
                <el-button type="primary" @click="toSubmitTwo" v-if="!$route.query.phoneOrEmail">提交</el-button>
              </div>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="null"></div>
    </div>
    <Bottom></Bottom>
  </div>
</template>

<script>
import { repasswordSetApi,repasswordApi } from "../api/index";
export default {
  name: "forget",
  data() {
    return {
      registerForm: {
        phoneOrEmail: "",
        password: "",
        passwordAgain: "",
      },
    };
  },
  created() {
    if(this.$route.query.phoneOrEmail) {
      this.registerForm.phoneOrEmail = this.$route.query.phoneOrEmail
    }
  },
  methods: {
    toCancel() {
      this.$router.push({
        name: "Home",
      });
    },
    toSubmit() {
      if (!this.registerForm.password) {
        this.$message.warning("请输入登录密码");
        return;
      }
      if (!this.registerForm.passwordAgain) {
        this.$message.warning("请再次输入登录密码");
        return;
      }
      if (this.registerForm.passwordAgain !== this.registerForm.password) {
        this.$message.warning("请确保两次密码输入正确");
        return;
      }
      if (this.loading) {
        return;
      }
      this.loading = true;
      repasswordSetApi({
        phoneOrEmail: this.registerForm.phoneOrEmail,
        password: this.registerForm.password,
      })
        .then((res) => {
          if (res.resultStatus) {
            this.$message.success("重置密码成功");
          }
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          this.loding = false;
          this.toCancel()
        });
    },
    toSubmitTwo() {
      if (!this.registerForm.phoneOrEmail) {
        this.$message.warning("请输入手机号或者邮箱");
        return;
      }
      repasswordApi({
        phoneOrEmail: this.registerForm.phoneOrEmail,
      }).then((res) => {
        if (res.resultStatus) {
          this.$message.success("请留意您的邮箱信息");
        } else {
          this.$message.warning(res.errorMessage);
        }
      });
    },
  },
};
</script>

<style lang="less">
.register_page {
  width: 100%;
  height: 100%;
  background-image: url("../assets/img/login_bg.png");
  background-position: initial;
  background-size: cover;
  overflow-y: scroll;
  &::-webkit-scrollbar {
    width: 0.1rem;
    background-color: rgba(0, 0, 0, 0);
  }

  &::-webkit-scrollbar-thumb {
    background-color: #d4d4d4;
  }
  @media screen and (min-width: 480px) {
    .content_box {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      .register_form {
        width: 600px;
        min-height: 500px;
        background: #fff;
        margin-top: 60px;
        display: flex;
        flex-direction: column;
        align-items: center;
        box-sizing: border-box;
        padding: 32px 0 20px;
        border-radius: 10px;
        z-index: 1;
        .title {
          width: 100%;
          font-size: 21px;
          color: #333;
          font-weight: 700;
          text-align: center;
          letter-spacing: 1.2px;
          margin-bottom: 50px;
        }
        .subtitle {
          width: 502px;
          font-size: 14px;
          color: #999;
          margin-bottom: 40px;
          letter-spacing: 1.6px;
        }
        .input_box {
          width: 400px;
        }
        .action_box {
          display: flex;
          align-items: center;
          justify-content: flex-end;
        }
      }
      .null {
        width: 100%;
        height: 100px;
      }
      .tips {
        width: 420px;
        font-size: 12px;
        color: #aaa;
        margin-top: 2px;
      }
    }
  }
  @media only screen and (max-width: 480px) {
    .content_box {
      width: 100%;
      height: calc(100% - 40px);
      display: flex;
      flex-direction: column;
      align-items: center;
      .register_form {
        width: 100%;
        height: 100%;
        background: #fff;
        display: flex;
        flex-direction: column;
        align-items: center;
        box-sizing: border-box;
        padding: 32px 0 20px;
        z-index: 1;
        .title {
          width: 100%;
          font-size: 21px;
          color: #333;
          font-weight: 700;
          text-align: center;
          letter-spacing: 1.2px;
          margin-bottom: 40px;
        }
        .subtitle {
          width: 302px;
          font-size: 14px;
          color: #999;
          margin-bottom: 40px;
          letter-spacing: 1.6px;
        }
        .input_box {
          width: 250px;
        }
        .action_box {
          display: flex;
          align-items: center;
          justify-content: flex-end;
        }
      }
      .null {
        display: none;
      }
      .tips {
        width: 200px !important;
        font-size: 12px;
        color: #aaa;
        margin-top: 2px;
        display: flex;
        line-height: 16px;
      }
    }
  }
}
</style>